function fromGQL(obj) {
  const { value, ...returnableField } = obj;
  return { ...returnableField, editors: { value: '' } };
}

function toGQL() {
  return { value: {} };
}

export default {
  fromGQL,
  toGQL,
};
